export default "__VITE_ASSET__CqthYVkZ__"